import React, { useCallback, useState } from 'react';
import { ExecutiveRelationModal } from '@purchase/supplier';
import { useExecutiveRelationData } from './useExecutiveRelationData';
import { useExecutiveRelationMap } from './useExecutiveRelationMap';

interface ModalState {
  open: boolean;
  personName: string;
}

/**
 * 每个 Module 各自维护一个 Modal 实例。
 *
 * 后端三组对外关联画像按 personName 索引,前端不需要 personId/keyNo。
 *
 * 用法:
 *   const { openModal, modalElement } = useExecutiveRelationModal(formDetail);
 *   <ClickableName name="..." onClick={() => openModal({ name: "..." })} />
 *   {...其他 JSX}
 *   {modalElement}
 */
export function useExecutiveRelationModal(formDetail: any) {
  const relationNames = useExecutiveRelationMap(formDetail);
  const [state, setState] = useState<ModalState>({
    open: false,
    personName: '',
  });

  const openModal = useCallback(({ name }: { name: string }) => {
    setState({ open: true, personName: name });
  }, []);

  const handleClose = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  const dataSource = useExecutiveRelationData(state.personName, formDetail);

  return {
    openModal,
    modalElement: (
      <ExecutiveRelationModal
        open={state.open}
        onClose={handleClose}
        personName={state.personName}
        dataSource={dataSource}
      />
    ),
    hasRelationData: (name?: string) => relationNames.has(name),
  };
}
